import { isApolloError } from '@apollo/client';
import type { ErrorResponse } from '@apollo/client/link/error';
import type { GraphQLError } from 'graphql';
import handleUnknownApolloErrors from './handleUnknownApolloErrors';
import parseGraphQLError from './parseGraphQLError';

export default function handleApolloError(
  apolloError: Error | ErrorResponse,
  key?: string | Record<string, (error: GraphQLError) => unknown>,
  handler?: (error: GraphQLError) => unknown,
  fallback?: (error: GraphQLError) => unknown,
) {
  if (!apolloError) return;

  const handlers = typeof key === 'string' ? { [key]: handler } : key;
  const fallbackHandler = typeof key === 'string' ? fallback : handler;

  ('graphQLErrors' in apolloError
    ? apolloError.graphQLErrors ?? []
    : []
  ).forEach((err) => {
    const { code } = parseGraphQLError(err);
    if (code && handlers?.[code]) {
      handlers[code]?.(err);
    } else if (fallbackHandler) {
      fallbackHandler(err);
    }
  });

  if (!(apolloError instanceof Error) || isApolloError(apolloError)) {
    handleUnknownApolloErrors(
      apolloError,
      'handleApolloError',
      handlers ? Object.keys(handlers) : [],
    );
  }
}
